import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import DatePickerInner from "../widgets/DatePickerInner";
import getInvestimento from "../services/getInvestimento";
import moment from "moment";
import editInvestimento from "../services/editInvestimento";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class EditInvestimento extends React.Component {

constructor(props){
    super (props)

    this.state = {
        descrizione: '',
        importo_totale: '', 
        rateizzazione: [], 
    };

}

async componentDidMount() {

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    let current = cookies.get('investimento', { path: '/' });
    let investimento = await getInvestimento(username, token, current);

    var rateizzazione = JSON.parse(investimento.rate);
    rateizzazione = rateizzazione.sort((r1, r2) => {
        return moment(r1.data, 'DD/MM/yyyy').isBefore(moment(r2.data, 'DD/MM/yyyy')) ? -1 : 1;
    });

    this.setState({
        descrizione: investimento.descrizione, 
        importo_totale: investimento.totale, 
        rateizzazione, 
    });
}

addCampo() {
    let rate = this.state.rateizzazione;

    rate.push({ data: new Date(), importo: '', isNew: true });
    this.setState({ rateizzazione: rate });
}

delete(index) {
    var array = [...this.state.rateizzazione];

    array.splice(index, 1);
    this.setState({ rateizzazione: array });
}

render () {

    return (
    <>
        <PageTitle title={'Modifica investimento'} />  

        <TextInput name={'Descrizione dell\'investimento'} value={this.state.descrizione} 
            onChange={(text) => { this.setState({descrizione: text})}
        } />

        <TextInput noState={true} name={'Importo totale'} value={this.state.importo_totale}
            onChange={(text) => {
                var t = text.replace(/\./g, '');
                if(/[^0-9,]+/.test(t)) {
                    t = t.replace(/[^0-9]+/g, '');
                }
                var chunks = t.split(',');
                chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                t = chunks.join(',');
                this.setState({importo_totale: t.trim()});
            }}
        />

        <div style={{ height: 20 }}></div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
            <h3 style={{marginLeft: 5, marginTop: 15}}>Rate di pagamento</h3>
            <img src={require('../images/add.png')} alt="" style={{ marginLeft: 10, cursor: 'pointer', width: 20, height: 20 }} onClick={() => this.addCampo()}/>
        </div>
        { this.state.rateizzazione.map((rata, i) => {

            let dataCheck = moment(rata.data, 'DD/MM/yyyy').isBefore(moment()) && !rata.isNew;
            return(
                <div style={mainStyle}>
                    <DatePickerInner selected={moment(rata.data, 'DD/MM/yyyy').toDate()} onChange={date => {
                        
                        if (dataCheck) return;

                        let rate = this.state.rateizzazione;
                        rate[i].data = moment(date).format('DD/MM/yyyy');
                        this.setState({ rateizzazione: rate });
                    }} />
                    <div style={{ marginTop: -5, marginLeft: 5 }}>
                        <TextInput readOnly={dataCheck ? true : false} name="" value={rata.importo} onChange={(text) => {
                            let rate = this.state.rateizzazione;

                            var t = text.replace(/\./g, '');
                            if(/[^0-9,]+/.test(t)) {
                                t = t.replace(/[^0-9]+/g, '');
                            }
                            var chunks = t.split(',');
                            chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                            t = chunks.join(',');
                            rate[i].importo = t.trim();
                            this.setState({ rateizzazione: rate });
                        }} />
                    </div>
                    <img src={require('../images/close.png')} alt="" title="Rimuvi" style={{ cursor: 'pointer', width: 20, height: 20, marginLeft: 10, marginTop: 10 }} onClick={() => this.delete(i)} />
                </div>
            );
        })}

        <div style={{ height: 30 }}></div>

        <FixButton title={'Salva'} callback={() => this.save()} />
    </>
    );
}

    async save() {

        this.setState({ isLoading: true });

        if (!this.state.descrizione) {
            alert('Inserire una descrizione valida');
            return;
        }

        if (!this.state.importo_totale) {
            alert('Inserire un importo totale valido per proseguire.');
            return;
        }
        
        var rateizzazione = [];
        var pastCheck = false;
        var totale = 0.0;
        this.state.rateizzazione.forEach(r => {
            totale += parseFloat(r.importo.replace(/\./g, '').replace(',', '.'));
            rateizzazione.push({
                data: r.data, 
                importo: r.importo,
            });
            if (moment(r.data, 'DD/MM/yyyy').startOf('day').isSameOrBefore(moment()) && r.isNew) pastCheck = true;
        });

        if (pastCheck) {
            if (!window.confirm('Risultano impostate alcune rate passate. Saranno direttamente impostate come pagate nel sistema. Proseguire?')) return;
        }

        /*
        if (totale !== parseFloat(this.state.importo_totale.replace(/\./g, '').replace(',', '.'))) {
            alert('La somma delle rate deve essere uguale all\'importo totale impostato');
            return;
        }
        */

        let investimento = {
            id: cookies.get('investimento', { path: '/' }), 
            descrizione: this.state.descrizione, 
            importo: this.state.importo_totale, 
            rate: JSON.stringify(rateizzazione), 
        };

        let res = await editInvestimento(username, token, investimento);
        if (res.result === 'ok') {
            window.location.href = '/#/app/investimenti';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la modifica dell\'investimento. Per favore, riprova.');
    }

}

const mainStyle = {
    display: 'flex', 
    flexDirection: 'row', 
    marginBottom: 10, 
    borderRadius: 5,
    border: '1px solid darkgrey',
    maxHeight: 60,
    paddingTop: 10, 
    paddingBottom: 10, 
    paddingLeft: 10, 
    paddingRight: 10,
    marginLeft: 5, 
};

